import { CommonModule, DOCUMENT } from '@angular/common';
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	inject,
	Input,
	output,
	Renderer2,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { OffcanvasService } from '../../services/offcanvas.service';
import { SeparatorComponent } from '../separator/separator.component';
import { IMenusAPIResponse, ItemMenus } from '../../models/web/IMenusAPIResponse';
import { ComprarService } from '../../services/bottonComprar.service';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [
		SeparatorComponent,
		RouterLink,
		RouterModule,
		CommonModule
		// GetLocalidadesService
	],
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss'
})
export class HeaderComponent {
	@Input({ required: true }) menuPrincipal?: IMenusAPIResponse[];
	// private menusApiResponse = inject(GetMenuWebService);
	// menuPrincipal?: IMenusAPIResponse | undefined;
	private comprarService = inject(ComprarService);
	private offcanvasService = inject(OffcanvasService);
	private cdr = inject(ChangeDetectorRef);
	isOpen = false;
	public toggleClic = output<string>();
	public estado = false;
	private router = inject(Router);
	private document = inject(DOCUMENT);
	private elementRef = inject(ElementRef);
	menu: any;
	error: string | null = null;
	@ViewChild('mensajetop') miElemento!: ElementRef;
	@ViewChild('navbar') miElemento2!: ElementRef;
	constructor(private renderer: Renderer2, private el: ElementRef) {}
	ngOnInit() {
		this.offcanvasService.isOffcanvasVisible$.subscribe((isVisible) => (this.isOpen = isVisible));
	}
	// ngOnChanges(changes: SimpleChanges) {
	// 	if (changes['menuPrincipal'] && this.menuPrincipal) {
	// 		this.menu = this.menuPrincipal?.filter((menu) => menu.slug === 'menu-principal');
	// 		this.cdr.detectChanges();
	// 	}
	// }

	toggleOffcanvas() {
		const data = { desdeBoton: false, open: false };
		this.comprarService.setCompraInfo(data);
		this.offcanvasService.toggleOffcanvas();
	}
}
